import './tab-navigation.scss';

class TabNavigation {
    constructor (element, options) {
        // Defaults & Settings
        const defaults = {
            initAttr: 'data-tabnavigation',
            pathAttr: 'data-tabnavigation-path',
            tabValue: 'tab'
        };

        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$$tabs = this.$root.querySelectorAll(`[${this.settings.initAttr}="${this.settings.tabValue}"]`);
        this.$activeTab = Array.from(this.$$tabs).find(tab => tab.getAttribute('aria-selected') === 'true');
    }

    /**
     * Initializes the tab navigation component:
     * - Sets click event listeners on all tabs
     * - Dispatches an 'tab_navigation.initialized' event for the currently active tab
     */
    initialize () {
        this.setEvents();
    }

    /**
     * Updates the active state of all tabs:
     * - Sets `aria-selected` attribute for accessibility
     * - Dispatches a 'tab_navigation.change' event with details of the active tab
     */
    updateState () {
        this.$$tabs?.forEach($tab => {
            $tab.setAttribute('aria-selected', $tab === this.$activeTab);
        });

        this.$root.dispatchEvent(new CustomEvent('tab_navigation.change', {
            detail: {
                $tab: this.$activeTab,
                id: this.$activeTab.getAttribute('aria-controls'),
                url: this.$activeTab.getAttribute(this.settings.pathAttr)
            },
            bubbles: true
        }));
    }

    /**
     * Sets event listeners on each tab:
     * - Click on a tab updates the active tab and triggers `updateState()`
     * - Dispatches 'tab_navigation.initialized' event for the initially active tab
     */
    setEvents () {
        this.$$tabs?.forEach($tab => {
            $tab.addEventListener('click', () => {
                if ($tab.getAttribute('aria-selected') === 'false') {
                    this.$activeTab = $tab;
                    this.updateState();
                }
            });
        });

        if (this.$activeTab) {
            this.$root.dispatchEvent(new CustomEvent('tab_navigation.initialized', {
                detail: {
                    $tab: this.$activeTab,
                    id: this.$activeTab.getAttribute('aria-controls'),
                    url: this.$activeTab.getAttribute(this.settings.pathAttr)
                },
                bubbles: true
            }));
        }

        window.addEventListener('siteheader.visibility', (e) => {
            const { visible, height } = e.detail;
            this.$root.style.setProperty('--tab-navigation-offset', visible ? `${height}px`: '0px');
        });
    }
}

export { TabNavigation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-tabnavigation="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new TabNavigation($root);
            $rootAPI.initialize();
        });
    }
});
